import datetimeProvider from "../../../providers/datetime.provider";
import api from '../../services/api';


const baseUrl = 'marketing/email/campaigns';

const findAll = async () =>
    api.get({ type: 'user', service: `${baseUrl}/` });

const findCampaignEmails = async (campaignId) =>
    api.get({ type: 'user', service: `${baseUrl}/${campaignId}/emails` })
        .then(({ data }) => data);

const create = async (campaign) =>
    api.post({
        type: "user",
        service: `${baseUrl}/`,
        data: campaign,
    });

const update = async (campaign) =>
    api.put({
        type: "user",
        service: `${baseUrl}/${campaign.id}`,
        data: campaign,
    });

const remove = async (campaign) =>
    api.remove({
        type: "user",
        service: `${baseUrl}/${campaign.id}`
    });

const findAllForList = async (listId) =>
    api.get({ type: 'user', service: `${baseUrl}/list/${listId}` });

const findAllListsForCampaign = async (campaignId, source) =>
    api.get({ type: 'user', service: `${baseUrl}/campaign-list/${campaignId}?source=${source}` });

const findTotalContactsBySegmentationPeriodFilter = async (listId, date) => {
    const queryString = date.initialDate && date.finalDate ? `initialDate=${date.initialDate}&finalDate=${date.finalDate}` : '';
    return api.get({ type: 'user', service: `marketing/email/lists/${listId}/total-contacts?${queryString}` });
}

const findTotalContactsInLists = async (listIds) =>
    api.post({ type: "user", service: `marketing/email/lists/total-contacts/`, data: { listIds }, })
        .then(({ data }) => data);

const subscribe = async (list) =>
    api.post({
        type: "user",
        service: `${baseUrl}/subscribe/`,
        data: list,
    });

const unsubscribe = async (list) =>
    api.post({
        type: "user",
        service: `${baseUrl}/unsubscribe/`,
        data: list,
    });

const sendTestEmail = async (contacts, emailData, templateId) =>
    api.post({
        type: "user",
        service: `${baseUrl}/test-email/`,
        data: { contacts, emailData, templateId },
    });

const findCampaignDetails = async (campaignId) =>
    api.get({ type: 'user', service: `${baseUrl}/${campaignId}` });

const findCampaignConversions = async (campaignId) =>
    api.get({ type: 'user', service: `${baseUrl}/${campaignId}/conversions` })
        .then(({ data }) => data);

const findDailyMetricsBetweenDates = async (campaignId, initialDate, finalDate) => {
    const data = {
        initialDate: datetimeProvider.formatDateTime(initialDate, 'YYYY-MM-DD'),
        finalDate: datetimeProvider.formatDateTime(finalDate, 'YYYY-MM-DD'),
    };

    return api.post({ type: 'user', service: `${baseUrl}/${campaignId}/daily-metrics`, data })
        .then(({ data }) => data);
}

export default {
    findAll,
    findAllForList,
    findAllListsForCampaign,
    findTotalContactsBySegmentationPeriodFilter,
    update,
    remove,
    create,
    subscribe,
    unsubscribe,
    findCampaignDetails,
    findCampaignConversions,
    findCampaignEmails,
    findTotalContactsInLists,
    findDailyMetricsBetweenDates,
    sendTestEmail,
};